import type { HeroContent } from "../data/portfolio";

type HeroProps = {
  hero: HeroContent;
  skills: string[];
};

const Hero = ({ hero, skills }: HeroProps) => {
  return (
    <section id="top" className="section hero">
      <div className="hero-grid">
        <div className="hero-copy">
          <p className="eyebrow">Computer Science Major</p>
          <h1>{hero.headline}</h1>
          <p className="lede">{hero.bio}</p>
        </div>
        <div className="hero-panel">
          <div className="panel">
            <div className="panel-header">
              <p>Core strengths</p>
            </div>
            <div className="skill-grid">
              {skills.map((skill) => (
                <span key={skill} className="pill">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
